import React from 'react';

const LenderPOV = () => {
  return (
    <div className="jo-xyz-demo-lender-pov-page">
      <div className="jo-xyz-demo-container">
        <h1>Lender Perspective</h1>
        <p>Lender portfolio and exposure management functionality coming soon...</p>
      </div>
    </div>
  );
};

export default LenderPOV;
